export default "<app-spinner></app-spinner>\n\n<router-outlet></router-outlet>\n"